export const getCoverPath = (categoryName, size = 'sm') => {
  return categoryName.toLowerCase() === 'вебинары'
    ? `/assets/img/webinar-cover_${size}.jpg`
    : `/assets/img/lesson-cover_${size}.jpg`
}
